import PropTypes from "prop-types";
import LinkedIN from "images/linkedin-dark.svg?react";
import Youtube from "images/youtube-dark.svg?react";
import Twitter from "images/icons-social-boxless-twitter-grey.svg?react";

const PublicPageHeaderConnect = ({ dataset }) => {
	let { isHidden = "false" } = dataset ? dataset : {};
	let queryString = decodeURIComponent(dataset.socialLinks).replace(/\+/g, " ");
	let social = JSON.parse(queryString);
	let { subLinks, label } = social;
	let { theme } = dataset;
	const renderIcon = (label) => {
		switch (label) {
			case "LinkedIn":
				return <LinkedIN />;
			case "YouTube":
				return <Youtube />;
			case "Twitter":
				return <Twitter />;
			default:
				return null;
		}
	};
	return isHidden === "false" ? (
		<div className={`public-page-header-connect ${theme}`}>
			<div className={`public-page-header-connect-title ${theme}`}>{label}</div>
			{subLinks && subLinks.length > 0 ? (
				<div className="public-page-header-connect-list">
					{subLinks.map((subLink, index) => {
						return (
							<div
								className={`public-page-header-connect-sublist ${subLink.label.toLowerCase()}`}
								key={index}
							>
								<a
									href={subLink.url}
									aria-label={subLink.label}
									target="_blank"
									rel="noopener noreferrer"
									className={theme}
								>
									{renderIcon(subLink.label)}
								</a>
							</div>
						);
					})}
				</div>
			) : null}
		</div>
	) : null;
};

PublicPageHeaderConnect.propTypes = {
	data: PropTypes.object,
	dataset: PropTypes.shape({ isHidden: PropTypes.string })
};

export default PublicPageHeaderConnect;
